import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FileIcon, defaultStyles } from 'react-file-icon';
import { IconDownload } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useDownloader from 'react-use-downloader';
import Loader from '../../../Loader';

export const ViewCompanys = (props) => {
  const [data, setData] = useState(props.data);
  const [loader, setLoader] = useState(false);
  const { download } = useDownloader();
  const token = useSelector((state) => state.token);

  const UpdateCompanies = () => {
    setLoader(true);
    axios({
      method: "PUT",
      url: `${process.env.REACT_APP_BASE_URL}/user/company/${data.userId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
      data: JSON.stringify({
        companyDetails: data.companies
      })
    }).then(res => {
      setLoader(false);
      props.onHide();
      props.getData();
      toast(res.data.message, {
        type: "success",
        theme: "light",
        position: "top-right"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0].msg, {
          type: "error",
          position: "top-right",
          theme: "light"
        });
      } else {
        toast(err?.response?.data?.message || err?.message || "Failed to update company", {
          type: "error",
          theme: "light",
          position: "top-right"
        });
      }
    });
  }

  useEffect(() => {
    setData(props.data);
  }, [props?.data?.userId]);
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Company Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive">
            {data?.companies?.length > 0 ?
              <>
                <table className="cptable modal-table">
                  <thead>
                    <tr class="d-none d-lg-table-row">
                      <th width="40%">Company name</th>
                      <th width="40%">Company details</th>
                      <th width="20%">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.companies?.map(p => {
                      return (
                        <tr class="tr">
                          <td><strong class="ht">Company name : </strong><small>{p.name}</small></td>
                          <td>
                            <strong class="ht">Company details : </strong>
                            <small className='d-flex align-items-center gap-2'>
                              <div className="doc-file">
                                <FileIcon extension={p?.document?.split('.')[1]} {...defaultStyles[p?.document?.split('.')[1]]} />
                              </div>
                              <button className='button yellow p-1 rounded-pill' onClick={() => download(`${process.env.REACT_APP_IMG_BASE_URL}${p?.document}`, p?.document?.split('company/')[1])}>
                                <IconDownload size={20} stroke={2} />
                              </button>
                            </small>
                          </td>
                          <td>
                            <strong class="ht">Status : </strong>
                            <small>
                              <Form.Select
                                value={p?.status}
                                size="sm"
                                className='form-control'
                                aria-label="Default select example"
                                onChange={(t) => {
                                  if (!t.target.value || t.target.value != "Pending" && t.target.value != "Approve" && t.target.value != "Rejected") {
                                    return;
                                  }
                                  const companies = data.companies.map(cm => {
                                    if (cm.name == p.name && cm.document == p.document) {
                                      return {
                                        ...cm,
                                        status: t.target.value
                                      }
                                    } else {
                                      return cm;
                                    }
                                  })
                                  setData((prevState) => ({
                                    ...prevState,
                                    companies:companies
                                  }));
                                }}>
                                <option>Select status</option>
                                <option value="Pending">Pending</option>
                                <option value="Approve">Approve</option>
                                <option value="Rejected">Rejected</option>
                              </Form.Select>
                            </small>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <button onClick={() => { UpdateCompanies() }} className="button blue py-2 px-3">Save</button>
              </>
              : <p>Companies not found</p>}
          </div>
        </Modal.Body>
      </Modal>
      <Loader show={loader}/>
    </>
  )
}
